const FAVICON_PATH = '/brand-assets/mtchat.svg';
const BADGED_FAVICON_PATH = '/brand-assets/mtchat-badge.svg';

export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    favicon.href = BADGED_FAVICON_PATH;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        favicon.href = FAVICON_PATH;
      });
    }
  });
};
